module.exports = "/img/automation/One-icon-animation.png?bcceece1727519cb487636dc5459353e";